<div class="cmn-dialog-card-view mesh-gradient">
    <button class="dialog-close-btn" (click)="closeDialog()">
        <img class="cross-icon" src="assets/svg/icons/cross.svg" />
    </button>
    <div class="dialog-header">
        <div class="dialog-header-icon">
            <img src="assets/svg/icons/badge-success-gb.svg" alt="" />
        </div>
        <div class="dialog-header-content">
            <h1 class="dialog-header-title">Nice one! Coupon applied</h1>
            <span>🎉</span>
        </div>
    </div>
    <mat-dialog-content>
        <div class="dialog-body">
            <p class="fs-md text-primary-50">The discount has been added to your loan amount</p>
            <div class="coupon-code-wrapper">
                <p class="fs-base uppercase">Coupon Code</p>
                <h4 class="fs-base">{{ this.data?.couponCode || "---" }}</h4>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="dialog-actions">
            <div class="dialog-actions-btn">
                <button
                    type="button"
                    class="primary-fill-btn btn-w100"
                    [disabled]="!this.data?.couponCode"
                    (click)="submit()"
                >
                    Let’s Go
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</div>
